<template>
  <modal-wrapper
    v-bind="$attrs"
    width="90%"
    height="auto"
    :name="name"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @close="close"
  >
    <template #content>
      <div
        v-if="!isLoading && hotel"
        class="hotel-mappings"
      >
        <header class="hotel-mappings__header">
          <div class="row">
            <div class="col">
              <div class="subtitle">
                Behind the scenes
              </div>
              <h2 class="title">
                <template v-if="activeTab !== 'all-rooms'">
                  {{ hotel.displayName }}
                </template>
                <template v-else>
                  {{ currentRoom.name }}
                </template>
              </h2>
            </div>
            <div class="hotel-mappings__created">
              Created 12/04/2018
            </div>
          </div>
          <div class="row">
            <hotel-short-data
              v-if="activeTab !== 'all-rooms'"
              :id="hotel.hotelId"
              :img="hotel.imageUrl"
              :name="hotel.displayName"
              :address="hotel.address"
              :city="hotel.cityName"
              :mappings="hotel.mapping"
              :stars="hotel.starRating"
              :rooms="hotel.roomCount"
              :zip-code="hotel.zipCode"
              :lat="hotel.lat"
              :lng="hotel.lng"
              :phone="hotel.phone.toString()"
              :email="hotel.email"
              :website="hotel.webSite"
            />
            <div
              v-else
              class="room__container"
            >
              <div class="room__gallery">
                <gallery
                  v-if="currentRoomImages"
                  :images="currentRoomImages"
                  url-field="url"
                  text-field="label"
                />
                <img
                  v-else
                  src="/images/content/img-no-room-placeholder.jpg"
                  alt=""
                >
              </div>
              <div class="room__text">
                <section class="room__information">
                  <h2 class="subtitle">
                    <span>Information</span>
                  </h2>
                  <read-more-text
                    v-if="currentRoomDescription"
                    :text="currentRoomDescription"
                    :html="true"
                    class="information"
                  />
                  <p v-else>
                    Not Provided
                  </p>
                </section>
                <section class="room__facilities">
                  <h2 class="subtitle">
                    <span>Facilities</span>
                  </h2>
                  <ul
                    v-if="currentRoom.topAmenities && currentRoom.topAmenities.length > 0"
                    class="list-facilities"
                  >
                    <li
                      v-for="amenity in currentRoom.topAmenities"
                      :key="amenity.id"
                      class="list-facilities__item"
                    >
                      <div class="facility">
                        <span
                          class="facility__icon"
                          v-html="require(`!svg-inline-loader?removeTags=true!@/assets/icons/facilities/room/${amenity.id}.svg`)"
                        />
                        <span>{{ amenity.label }}</span>
                      </div>
                    </li>
                  </ul>
                  <p v-else>
                    Not Provided
                  </p>
                </section>
              </div>
            </div>
          </div>
          <div class="tabs">
            <ul class="tabs__list">
              <li
                class="tabs__item"
                :class="{
                  'is-active': activeTab === 'mappings',
                }"
              >
                <a
                  href="#"
                  @click.prevent="activeTab = 'mappings'"
                >Mappings</a>
              </li>
              <li
                class="tabs__item"
                :class="{
                  'is-active': activeTab === 'automation',
                }"
              >
                <a
                  href="#"
                  @click.prevent="activeTab = 'automation'"
                >Automation</a>
              </li>
              <li
                class="tabs__item"
                :class="{
                  'is-active': activeTab === 'all-rooms',
                }"
              >
                <a
                  href="#"
                  @click.prevent="activeTab = 'all-rooms'"
                >All Rooms</a>
              </li>
            </ul>
          </div>
        </header>
        <div class="hotel-mappings__content">
          <div
            v-if="activeTab === 'mappings'"
            class="tabs-panel"
          >
            <data-table
              key="mappings"
              :headers="mappings.headers"
              :rows="mappings.rows"
            />
          </div>
          <div
            v-if="activeTab === 'automation'"
            class="tabs-panel"
          >
            <data-table
              key="automation"
              :headers="automation.headers"
              :rows="automation.rows"
            />
          </div>
          <div
            v-if="activeTab === 'all-rooms'"
            class="tabs-panel"
          >
            <all-rooms-item
              v-for="room in rooms"
              :key="`room-item-${room.id}`"
              v-bind="room"
              @open="onAllRoomsItemOpen"
              @close="onAllRoomsItemClose"
            />
          </div>
        </div>
      </div>
    </template>
  </modal-wrapper>
</template>
<script>
import { mapActions } from 'vuex';
import ModalWrapper from '@/components/modals/ModalWrapper';
import HotelShortData from '@/components/HotelShortData';
import DataTable from '@/components/DataTable';
import AllRoomsItem from '@/components/AllRoomsItem';
import Gallery from '@/components/Gallery';
import ReadMoreText from '@/components/ReadMoreText';

const name = 'modal-hotel-mappings';

const allRoomsTableHeaders = [
  'Supplier Room Name',
  'Supplier',
  'Price',
];

export default {
  name,
  components: {
    ModalWrapper,
    HotelShortData,
    DataTable,
    AllRoomsItem,
    Gallery,
    ReadMoreText,
  },
  data() {
    return {
      name,
      isLoading: false,
      hotel: null,
      rooms: null,
      currentRoom: null,
      roomImages: null,
      activeTab: 'mappings',
      automation: {
        headers: [
          'Sup. ID',
          'Supplier',
          'Cycle Stat.',
          'Change over Time',
          'Date',
          '% Changed',
          'Current',
          'Next',
          'Candidates',
          'Delete',
          'Add',
          'Reactivated',
          '# Errors',
          'Updated',
          'Q. Score',
          'Images',
        ],
        rows: [],
      },
      mappings: {
        headers: [
          'Supplier',
          'Supplier Key',
          'Name',
          'Address',
          'City',
          'Country Code',
          'Stars',
          'Rooms',
          'ZIP Code',
          'LAT/LNG',
          'Phone',
          'Email',
          'Web',
        ],
        rows: [],
      },
      descriptions: null,
    };
  },
  computed: {
    currentRoomImages() {
      const images = this.roomImages[this.currentRoom.id];
      if (!images || images.length === 0) return null;
      return images.map(url => ({
        url,
        label: 'Room Photo',
      }));
    },
    currentRoomDescription() {
      return this.descriptions[this.currentRoom.id] || null;
    },
  },
  methods: {
    ...mapActions([
      'getHotelMappings',
      'getHotelRooms',
      'getHotelAutomation',
      'getRoomsDescription',
    ]),
    onAllRoomsItemOpen(id) {
      this.currentRoom = this.rooms.find(room => room.id === id);
      this.rooms.forEach(room => {
        room.isOpen =
          room.id === id
            ? !room.isOpen
            : false;
      });
    },
    onAllRoomsItemClose(id) {
      const item = this.rooms.find(room => room.id === id);
      if (item) {
        item.isOpen = false;
      }
    },
    close() {
      this.$modal.hide(this.name);
    },
    closeByEscape(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
    async beforeOpen(event) {
      const loader = this.$loading.show();
      this.isLoading = true;

      this.hotel = null;
      this.rooms = null;
      this.roomImages = null;
      this.activeTab = 'mappings';

      if (event.params) {
        this.hotel = event.params.hotel;

        this.rooms = Object.keys(event.params.rooms).map((roomKey, index) => ({
          id: roomKey,
          img: event.params.rooms[roomKey].mainImg,
          name: event.params.rooms[roomKey].rooms[0].roomName,
          sourcesHeaders: allRoomsTableHeaders,
          sourcesList: event.params.rooms[roomKey].rooms.map(room => [
            { text: room.supplierRoomName },
            { text: room.supplier },
            { text: `$${room.price}` },
          ]),
          isOpen: event.params.roomKey ? roomKey === event.params.roomKey : index === 0,
          topAmenities: event.params.rooms[roomKey].topAmenities,
        }));

        this.currentRoom = this.rooms.find(({ isOpen }) => isOpen) || null;

        this.roomImages = event.params.roomImages;

        this.activeTab = event.params.activeTab || 'mappings';
      }

      const [
        mappings,
        automations,
        descriptions,
      ] = await Promise.all([
        this.getHotelMappings(this.hotel.hotelId),
        this.getHotelAutomation(),
        this.getRoomsDescription(this.hotel.hotelId),
      ]);

      this.mappings.rows = mappings.map(mapping => [
        { text: mapping.supplier },
        { text: mapping.supplierKey.toString().slice(0, 10) },
        { text: mapping.displayName },
        { text: mapping.address },
        { text: mapping.cityName },
        { text: mapping.countryCode },
        { text: mapping.starRating },
        { text: mapping.roomCount },
        { text: mapping.zipCode },
        {
          text: (function () {
            if (mapping.lat === 0 || mapping.lng === 0) return null;
            return `${mapping.lat.toString().replace(',', '.')}/${mapping.lng.toString().replace(',', '.')}`;
          })(),
        },
        { text: mapping.phone ? mapping.phone.toString().split('\\')[0] : null },
        { text: mapping.email.split(',')[0] },
        { text: mapping.webSite },
      ]);

      this.automation.rows = automations.map(automation => [
        { text: automation.supplierId },
        { text: automation.supplierName },
        { text: automation.cycleStatus },
        { type: 'chart' },
        { text: automation.date },
        { text: automation.changed },
        { text: automation.current },
        { text: automation.next },
        { text: automation.candidates },
        { text: automation.deleted },
        { text: automation.added },
        { text: automation.reactivated },
        { text: automation.errors },
        { text: automation.updated },
        { text: `${automation.qScore}%` },
        { text: automation.images },
      ]);

      this.descriptions = descriptions;

      document.addEventListener('keyup', this.closeByEscape);

      loader.hide();
      this.isLoading = false;
    },
    beforeClose() {
      document.removeEventListener('keyup', this.closeByEscape);
    },
  },
};
</script>
<style lang="scss" scoped>
.hotel-mappings {
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  &__created {
    background: #fff;
    color: #6e7c91;
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    padding: 6px 10px 5px;
    border-radius: 3px;
    cursor: default;
  }
  &__header {
    background: #f7f9fc;
    color: #6e7c91;
    padding: 30px 30px 0;
    flex: 0 0 1%;
    @media screen and (max-width: 1024px) {
      padding: 15px 15px 0;
    }
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > * {min-width: 0;}
      & + * {margin-top: 15px;}
    }
    .subtitle {
      text-transform: uppercase;
      font-size: 9px;
      line-height: 14px;
    }
    .title {
      font-size: 15px;
      line-height: 20px;
      font-weight: bold;
    }
  }
  &__content {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .tabs {
    margin-left: -20px;
    font-size: 13px;
    line-height: 16px;
    font-weight: bold;
    text-transform: uppercase;
    &__list {
      display: flex;
    }
    &__item {
      a {
        display: block;
        padding: 13px 20px;
        position: relative;
        text-decoration: none;
        color: currentColor;
        &:after {
          content: '';
          position: absolute;
          height: 4px;
          background: currentColor;
          bottom: -2px;
          border-radius: 2px;
          left: 7px;
          right: 7px;
          opacity: 0;
          transition: opacity 0.15s ease-in-out;
        }
      }
      &.is-active a {
        color: #6972de;
        &:after {opacity: 1;}
      }
    }
  }
}
.tabs-panel {
  height: 100%;
  overflow: auto;
  padding: 10px;
}

.room {
  &__container {
    display: flex;
    flex: 1;
    & > * {
      margin: 0 15px;
      @media (min-width: 1025px) {
        margin: 0 30px;
      }
      &:first-child {margin-left: 0;}
      &:last-child {margin-right: 0;}
    }
    justify-content: space-between;
  }
  &__gallery {
    width: 300px;
    flex: 0 0 300px;
    & > img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  &__text {
    flex: 1 1 auto;

    @media screen and (min-width: 1025px) {
      display: flex;
      & > * {
        margin: 0 5px;
        flex: 1;
        &:first-child {margin-left: 0;}
        &:last-child {margin-right: 0;}
      }
      section {margin-top: 0 !important;}
    }
    & > section + section {
      margin-top: 20px;
    }
    .subtitle {
      font-size: 15px;
      line-height: 24px;
      font-weight: bold;
      color: #6e7c91;
      & > * {
        margin: 0 6px;
        &:first-child {margin-left: 0;}
        &:last-child {margin-right: 0;}
      }
      display: flex;
      align-items: flex-start;
      & + * {margin-top: 10px;}
      @media screen and (min-width: 1025px) {
        & + * {margin-top: 22px;}
      }
    }
  }
  &__facilities {
    .list-facilities {
      display: flex;
      flex-wrap: wrap;
      & > * {
        margin: 0 20px 10px 0;
        @media screen and (min-width: 1025px) {
          margin: 0 40px 20px 0;
        }
      }
      max-width: 600px;
    }
  }
  &__information {
    .information {
      max-height: 200px;
      overflow: auto;
    }
  }
}
</style>
